import { render, staticRenderFns } from "./MitMenu.vue?vue&type=template&id=24331150"
import script from "./MitMenu.vue?vue&type=script&lang=js"
export * from "./MitMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports